import * as React from 'react';
import { styled, ThemeProvider } from '../theme-provider';
import { getMediaQueryVars } from '../theme-provider/get-media-query-vars';
const StyledApplicationRoot = styled.div.withConfig({ displayName: "StyledApplicationRoot", componentId: "sc-1mahok8" }) `${getMediaQueryVars()};`;
export const ApplicationRoot = ({ children }) => (React.createElement(ThemeProvider, { theme: "main" },
    React.createElement(StyledApplicationRoot, null, children)));
